import DatePanel from "react-multi-date-picker/plugins/date_panel";
import DatePicker, { DateObject } from "react-multi-date-picker";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import Button from "react-multi-date-picker/components/button";
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";
import { useContext, useEffect, useState } from "react";
import "react-multi-date-picker/styles/colors/teal.css";
import { GrTransaction } from "react-icons/gr";
import { isEmpty } from "lodash";

import { transactionsCustomerContext } from "../../../context/CustomerContext/TransactionsCustomerContext/TransactionsCustomerContext";
import CustomerLastMobileView from "./ViewMode/CustomerLastMobileView";
import CustomerLastPcView from "./ViewMode/CustomerLastPcView";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import { formatToPersianDate } from "../../../utils";
import MenuUi from "../../../helpers/MenuUi/MenuUi";

// Date Picker Package

// Date Picker Style Package

const CustomerLastTransactions = () => {
  const {
    getOrdersHistoryCustomer,
    setStartDate,
    productType,
    setProductType,
    handleGetOrderHistory,
    handleSubmitCustomer,
  } = useContext(transactionsCustomerContext);

  //* Get Data Start
  useEffect(() => {
    handleGetOrderHistory();
  }, []);

  const [values] = useState([
    new DateObject({ calendar: persian }).subtract(7, "days"),
    new DateObject({ calendar: persian }).add(0, "days"),
  ]);
  //* Get Data End

  return (
    <>
      <SiteTitle title="آخرین معاملات" />
      <div className="mr-auto w-full h-screen">
        {/* Menu */}
        <MenuUi className={"top-3"} />
        <div className="flex w-full h-full justify-center overflow-y-scroll items-center bg-mainBackground relative">
          <div
            className={`${isEmpty(getOrdersHistoryCustomer) ? "h-full" : null}
            w-full left-0 md:top-0 top-8 absolute mx-auto overflow-y-scroll grid gap-y-10 px-6 py-4 justify-items-center
              `}
          >
            {/* Filters */}
            <div className="flex justify-center items-center w-full h-full">
              <form
                onSubmit={handleSubmitCustomer}
                className="w-full h-full flex flex-row justify-center items-center md:pt-0 pt-3"
              >
                {/* Select Options */}
                <span className="md:mx-2 px-1 h-full">
                  <select
                    className="px-3 bg-transparent border-b border-green-500 w-full h-full
                    rounded-md focus:right-0 focus:outline-none text-slate-200 cursor-pointer
                    focus:border-2 focus:border-green-500 focus:text-green-500"
                    onChange={(e) => setProductType(e.target.value)}
                    value={productType}
                  >
                    <option
                      className="text-slate-200 p-1 bg-boxColor"
                      value={""}
                    >
                      همه
                    </option>
                    <option
                      className="text-slate-200 p-1 bg-boxColor"
                      value={"L"}
                    >
                      لغو شده
                    </option>
                    <option
                      className="text-slate-200 p-1 bg-boxColor"
                      value={"T"}
                    >
                      تأیید شده
                    </option>
                  </select>
                </span>
                {/* Date Picker */}
                <span className="text-white flex items-center md:mx-2 px-1 border-b border-green-500 rounded-md">
                  <DatePicker
                    className="rmdp-prime bg-dark"
                    value={values}
                    onChange={setStartDate}
                    range
                    showOtherDays
                    render={<Button />}
                    plugins={[<DatePanel position="left" />]}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-left"
                  />
                </span>
                {/* Button */}
                <span className="md:mx-2 px-1 h-full">
                  <button
                    type="submit"
                    className="px-3 py-1.5 text-sm font-medium h-full
                    rounded-md bg-transparent hover:bg-[#1A1D27]
                    text-slate-200 border-b border-green-500"
                  >
                    دریافت اطلاعات
                  </button>
                </span>
              </form>
            </div>
            {/* List */}
            {isEmpty(getOrdersHistoryCustomer) ? (
              <>
                <span
                  className="w-full h-screen space-y-5 text-slate-200 
                  text-xl flex flex-col justify-center items-center"
                >
                  <span>
                    <GrTransaction size={60} />
                  </span>
                  <p>تاریخچه ای وجود ندارد</p>
                </span>
              </>
            ) : (
              <>
                {getOrdersHistoryCustomer.map((_item) => (
                  <>
                    <div
                      key={_item.id}
                      className="w-full animate__animated animate__fadeIn animate__slow"
                    >
                      <span className="flex flex-col">
                        {/* WeekDays */}
                        <div
                          className="flex justify-between text-lg text-slate-200
                           px-5 py-2 mr-auto w-full 2xl:w-[95%] xl:w-[93%] lg:w-[90%]"
                        >
                          <p>{_item?.weekday}</p>
                          <p>{formatToPersianDate(_item?.date)}</p>
                        </div>

                        {/* PC View */}
                        <span className="lg:flex hidden">
                          <CustomerLastPcView _item={_item} />
                        </span>

                        {/* Mobile View */}
                        <span className="lg:hidden none">
                          <CustomerLastMobileView _item={_item} />
                        </span>
                      </span>
                    </div>
                  </>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerLastTransactions;
